// import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

/* Sentry.init({
  dsn: "https://e7a3059149c21b853e69194ea4b4b132@o4508196331651072.ingest.us.sentry.io/4508200900296704",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  environment: "production",
}); */

/*
 * "ResizeObserver loop completed with undelivered notifications"
 *
 * Não é erro de aplicação. É um aviso do próprio navegador, previsto na
 * especificação: acontece quando o callback de um ResizeObserver altera o
 * layout e a notificação não cabe no mesmo quadro de renderização. O navegador
 * simplesmente entrega no quadro seguinte — nada quebra, nada fica pendente.
 *
 * Quem o transforma em tela vermelha é o overlay do webpack-dev-server, que
 * escuta o evento `error` da janela. **Esse overlay só existe em
 * desenvolvimento**: o build de produção não o contém, então ninguém no
 * escritório jamais viu essa mensagem.
 *
 * Aqui ele atrapalhava, porque aparecia em várias telas (agendamento, busca de
 * processos) e escondia o overlay de erros de verdade. A origem é o PrimeReact,
 * que observa redimensionamento em tabelas e dropdowns.
 *
 * O filtro casa apenas com as duas mensagens conhecidas do ResizeObserver;
 * qualquer outro erro continua chegando ao overlay normalmente.
 */
const AVISO_RESIZE_OBSERVER =
  /^ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;

window.addEventListener("error", (evento) => {
  if (AVISO_RESIZE_OBSERVER.test(evento.message)) {
    evento.stopImmediatePropagation();
  }
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root"),
);
